import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./redux/app/store";
import Header from "./components/Header";
import SideBar from "./components/SideBar";
import JobFeed from "./pages/JobFeed";
import AddJob from "./pages/AddJob";
import EditJob from "./pages/EditJob";

export default function App() {
  return (
    <BrowserRouter>
      <Provider store={store}>
        <Header />
        <div className="max-w-[90rem] mx-auto px-4 sm:px-6 md:px-8">
          <SideBar />
          <Routes>
            <Route path="/" element={<JobFeed />}></Route>
            <Route path="/create" element={<AddJob />}></Route>
            <Route path="/editjob/:id" element={<EditJob />}></Route>
          </Routes>
        </div>
      </Provider>
    </BrowserRouter>
  );
}
